import Vue from 'vue';
import Axios from 'axios';
// Vue.config.devtools = true;
new Vue({
	el:"#scope-board"
	,data:function(){
		return {
			viewModel:{
        inquiry: {
          qproduct: 'PRD_0001'
        },
			}
		}
	}	
	,mounted:function(){
    // console.log(window)
	}
	,methods:{
    fnGetList: function() {
      let vm=this;
      Axios.post("/selectBoardList",{}).then(function(response){
        console.log(response.data);
      })
      .catch(function(error){
        console.log(error);
      });
    },
    fnSave: function() {
      let vm = this;
      var reg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      var regNum = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

      if(vm.viewModel.inquiry.qname=='' || vm.viewModel.inquiry.qname==undefined) {
        alert('담당자 성함을 입력해주세요');
        $('#qname').focus();
        return false;
      } else if(vm.viewModel.inquiry.qemail=='' || vm.viewModel.inquiry.qemail==undefined) {
        alert('이메일을 입력해주세요')
        $('#qemail').focus();
        return false;
      } else if(!vm.viewModel.inquiry.qemail.match(reg)) {
        alert('이메일 형식을 지켜주세요. 예)sample@email.com');
        $('#qemail').focus();
        return false;
      // } else if(vm.viewModel.inquiry.qcontact=='' || vm.viewModel.inquiry.qcontact==undefined) {
      //   alert('연락처를 입력해주세요')
      //   $('#qcontact').focus();
      //   return false;
      // } else if(!vm.viewModel.inquiry.qcontact.match(regNum)) {
      //   alert('연락처 형식을 다시 확인해주세요.')
      //   $('#qcontact').focus();
      //   return false;
      } else if(vm.viewModel.inquiry.qcontents=='' || vm.viewModel.inquiry.qcontents==undefined) {
        alert('내용을 입력해주세요')
        $('#qcontents').focus();
        return false;
      } else if(vm.viewModel.inquiry.qtype=='' || vm.viewModel.inquiry.qtype==undefined) {
        alert('상담신청 종류를 선택해주세요')
        $('#qtype').focus();
        return false;
      }

      let data = {
        qname: vm.viewModel.inquiry.qname,
        qcompany: vm.viewModel.inquiry.qcompany,
        qemail: vm.viewModel.inquiry.qemail,
        // qcontact: vm.viewModel.inquiry.qcontact,
        qcontents: vm.viewModel.inquiry.qcontents,
        qproduct: vm.viewModel.inquiry.qproduct,
        qtype: vm.viewModel.inquiry.qtype,
      };

      if(confirm("등록하시겠습니까?")) {
        $('.loading').show();
          Axios.post("/insertBoard", data).then(function(response) {
            if(response.data == 1) {
              $('.loading').hide();
              alert("문의사항이 접수되었습니다.");
              vm.viewModel.inquiry = {qproduct: 'PRD_0001'};
              $('.qcontrol label').trigger('click');
              $('#mQuestion .btn-close').trigger('click');
              window.location.hash = '#section18';
            } else {
              $('.loading').hide();
              alert("접수 중 오류가 발생했습니다.%n관리자에게 문의해주세요.")
            }
          }).catch(function(ex) {
              console.log(ex);
          });
      }
    },
    fnAutoHyphen: function(num) {
      if(num.data != null) {
        if(!(num.data.match(/[0-9]/) && num.isTrusted == true)) {
          alert('숫자만 입력해주세요')
        }
        var replaceNum = num.target.value.replace(/[^0-9]/g, '')
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
        num.target.value = replaceNum;
        this.viewModel.inquiry.qcontact = replaceNum;
      }
    }
  }
});


// WEBPACK FOOTER //
// ./src/safetyet-board.js